module.exports = __webpack_public_path__ + "static/mo11-a3b6fad4996d0d3907ea5b46bb9e05de.png";